/**
 * @file ReportShell.tsx
 * @brief Company Admin wrapper around shared ReportShell.
 *
 * @author DES
 * @date 27-07-2026
 */

import {
  ReportShell as SharedReportShell,
  type ReportShellProps as SharedProps,
} from "@/features/reports-shared/ReportShell";

export type ReportShellProps = Omit<SharedProps, "catalogTo">;

export function ReportShell(props: ReportShellProps) {
  return <SharedReportShell catalogTo="/company/reports" {...props} />;
}
